export function getRandomIntInclusive(fmin: number, fmax: number): number {
  const min = Math.ceil(fmin);
  const max = Math.floor(fmax);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
